(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers-tp"] && !Shopify.designMode) return;
  try {
    
(function(){
  function formatPrice(cents){ return '€' + (cents / 100).toFixed(2).replace('.', ','); }

  function initCards(scope) {
    scope.querySelectorAll('.tp-bs .tp-product-card[data-product-id]').forEach(card => {
      if (card.dataset.tpInit === '1') return;
      card.dataset.tpInit = '1';

      const dataScript = card.querySelector('.tp-card-variants-data');
      if (!dataScript) return;
      let variants;
      try { variants = JSON.parse(dataScript.textContent); } catch(e) { return; }
      if (!variants || !variants.length) return;

      const pills = card.querySelectorAll('.tp-card-variant-pill');
      const priceDisplay = card.querySelector('[data-price-display]');
      const variantInput = card.querySelector('[data-variant-input]');
      const addBtn = card.querySelector('[data-add-btn]');
      const addText = card.querySelector('[data-add-text]');
      const stockEl = card.querySelector('[data-stock-display]');
      const imgEl = card.querySelector('.tp-card-image img');
      const defaultImg = imgEl ? imgEl.src : null;

      const I18N = { in_stock: 'In stock', out_of_stock: 'Out of stock', add_to_cart: 'Add to cart', unavailable: 'Unavailable' };

      function getSelectedOpts() {
        const groups = {};
        pills.forEach(p => { if (p.classList.contains('active')) groups[p.dataset.optionIndex] = p.dataset.optionValue; });
        const opts = [];
        for (let i = 0; i < 3; i++) opts.push(groups[i] !== undefined ? groups[i] : variants[0]['option' + (i + 1)]);
        return opts;
      }
      function findVariant(opts) {
        return variants.find(v =>
          (v.option1 === opts[0] || (v.option1 == null && opts[0] == null)) &&
          (v.option2 === opts[1] || (v.option2 == null && opts[1] == null)) &&
          (v.option3 === opts[2] || (v.option3 == null && opts[2] == null))
        );
      }
      function updateCard() {
        const opts = getSelectedOpts();
        const variant = findVariant(opts);
        if (!variant) return;
        if (priceDisplay) priceDisplay.textContent = formatPrice(variant.price);
        if (variantInput) variantInput.value = variant.id;
        if (imgEl) imgEl.src = variant.image || defaultImg;
        if (addBtn) {
          addBtn.disabled = !variant.available;
          if (addText) addText.textContent = variant.available ? I18N.add_to_cart : I18N.unavailable;
        }
        if (stockEl) {
          stockEl.classList.toggle('in-stock', variant.available);
          stockEl.classList.toggle('out-of-stock', !variant.available);
          const stockText = stockEl.querySelector('[data-stock-text]');
          if (stockText) stockText.textContent = variant.available ? I18N.in_stock : I18N.out_of_stock;
        }
      }
      pills.forEach(pill => {
        pill.addEventListener('click', (e) => {
          e.preventDefault();
          const idx = pill.dataset.optionIndex;
          card.querySelectorAll('.tp-card-variant-pill[data-option-index="' + idx + '"]').forEach(p => p.classList.remove('active'));
          pill.classList.add('active');
          updateCard();
        });
      });
    });
  }
  initCards(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-tp"] && !Shopify.designMode) return;
  try {
    
(function () {
  const root = document.querySelector('[data-tp-faq]');
  if (!root) return;

  const search = root.querySelector('.tp-faq-search');
  const items = root.querySelectorAll('[data-tp-faq-item]');
  const groups = root.querySelectorAll('[data-tp-faq-group]');
  const empty = root.querySelector('.tp-faq-empty');

  if (search) {
    search.addEventListener('input', () => {
      const q = search.value.trim().toLowerCase();
      let totalVisible = 0;
      items.forEach(item => {
        const text = (item.textContent || '').toLowerCase();
        const match = !q || text.includes(q);
        item.style.display = match ? '' : 'none';
        if (match) totalVisible++;
      });
      groups.forEach(g => {
        const visibleInGroup = g.querySelectorAll('[data-tp-faq-item]:not([style*="display: none"])').length;
        g.style.display = visibleInGroup === 0 ? 'none' : '';
      });
      if (empty) empty.hidden = totalVisible > 0;
    });
  }

  // Sidebar active state on scroll
  const catLinks = root.querySelectorAll('[data-tp-faq-cat]');
  if (catLinks.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const id = entry.target.id;
          catLinks.forEach(l => l.classList.toggle('is-active', l.getAttribute('href') === '#' + id));
        }
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    groups.forEach(g => observer.observe(g));
  }

  catLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.querySelector(link.getAttribute('href'));
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // Live chat trigger — opens Shopify Inbox (Shadow DOM web component)
  function openChat() {
    // Shopify Inbox v2: button is inside Shadow DOM of <inbox-online-store-chat>
    const host = document.querySelector('inbox-online-store-chat');
    if (host && host.shadowRoot) {
      const btn = host.shadowRoot.querySelector('button.chat-toggle, [class^="chat-toggle--"], button');
      if (btn) { btn.click(); return true; }
    }
    // Fallback: light-DOM Inbox button
    const lightBtn = document.querySelector('#chat-button-container [class^="chat-toggle--"], #chat-button-container button');
    if (lightBtn) { lightBtn.click(); return true; }
    // Other chat platforms
    if (window.Tawk_API && typeof window.Tawk_API.maximize === 'function') { window.Tawk_API.maximize(); return true; }
    if (window.$zopim && window.$zopim.livechat) { window.$zopim.livechat.window.show(); return true; }
    if (window.Intercom) { window.Intercom('show'); return true; }
    if (window.fcWidget && window.fcWidget.open) { window.fcWidget.open(); return true; }
    return false;
  }

  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href="#tp-open-chat"]');
    if (!link) return;
    e.preventDefault();
    if (!openChat()) {
      window.location.href = '/pages/contact';
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products-tp"] && !Shopify.designMode) return;
  try {
    
(function(){
  function formatPrice(cents){ return '€' + (cents / 100).toFixed(2).replace('.', ','); }

  function initCards(scope) {
    scope.querySelectorAll('.tp-fp .tp-product-card[data-product-id]').forEach(card => {
      if (card.dataset.tpInit === '1') return;
      card.dataset.tpInit = '1';

      const dataScript = card.querySelector('.tp-card-variants-data');
      if (!dataScript) return;
      let variants;
      try { variants = JSON.parse(dataScript.textContent); } catch(e) { return; }
      if (!variants || !variants.length) return;

      const pills = card.querySelectorAll('.tp-card-variant-pill');
      const priceDisplay = card.querySelector('[data-price-display]');
      const variantInput = card.querySelector('[data-variant-input]');
      const addBtn = card.querySelector('[data-add-btn]');
      const addText = card.querySelector('[data-add-text]');
      const stockEl = card.querySelector('[data-stock-display]');
      const imgEl = card.querySelector('.tp-card-image img');
      const defaultImg = imgEl ? imgEl.src : null;

      const I18N = { in_stock: 'In stock', out_of_stock: 'Out of stock', add_to_cart: 'Add to cart', unavailable: 'Unavailable' };

      function getSelectedOpts() {
        const groups = {};
        pills.forEach(p => { if (p.classList.contains('active')) groups[p.dataset.optionIndex] = p.dataset.optionValue; });
        const opts = [];
        for (let i = 0; i < 3; i++) opts.push(groups[i] !== undefined ? groups[i] : variants[0]['option' + (i + 1)]);
        return opts;
      }
      function findVariant(opts) {
        return variants.find(v =>
          (v.option1 === opts[0] || (v.option1 == null && opts[0] == null)) &&
          (v.option2 === opts[1] || (v.option2 == null && opts[1] == null)) &&
          (v.option3 === opts[2] || (v.option3 == null && opts[2] == null))
        );
      }
      function updateCard() {
        const opts = getSelectedOpts();
        const variant = findVariant(opts);
        if (!variant) return;
        if (priceDisplay) priceDisplay.textContent = formatPrice(variant.price);
        if (variantInput) variantInput.value = variant.id;
        if (imgEl) imgEl.src = variant.image || defaultImg;
        if (addBtn) {
          addBtn.disabled = !variant.available;
          if (addText) addText.textContent = variant.available ? I18N.add_to_cart : I18N.unavailable;
        }
        if (stockEl) {
          stockEl.classList.toggle('in-stock', variant.available);
          stockEl.classList.toggle('out-of-stock', !variant.available);
          const stockText = stockEl.querySelector('[data-stock-text]');
          if (stockText) stockText.textContent = variant.available ? I18N.in_stock : I18N.out_of_stock;
        }
      }
      pills.forEach(pill => {
        pill.addEventListener('click', (e) => {
          e.preventDefault();
          const idx = pill.dataset.optionIndex;
          card.querySelectorAll('.tp-card-variant-pill[data-option-index="' + idx + '"]').forEach(p => p.classList.remove('active'));
          pill.classList.add('active');
          updateCard();
        });
      });
    });
  }
  initCards(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero-tp"] && !Shopify.designMode) return;
  try {
    
(function() {
  const hero = document.currentScript ? document.currentScript.closest('section.tp-hero') : null;
  const scope = hero || document.querySelector('[data-tp-hero]');
  if (!scope) return;

  const slides = scope.querySelectorAll('[data-tp-hero-slide]');
  const dots = scope.querySelectorAll('[data-tp-hero-dot]');
  if (slides.length < 2) return;

  let current = 0;
  let timer = null;
  const autoplay = scope.dataset.autoplay === 'true';
  const interval = (parseFloat(scope.dataset.autoplaySeconds) || 6) * 1000;

  function show(idx) {
    slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
    dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    current = idx;
  }
  function next() { show((current + 1) % slides.length); }
  function start() {
    if (!autoplay) return;
    stop();
    timer = setInterval(next, interval);
  }
  function stop() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  dots.forEach((d, i) => {
    d.addEventListener('click', () => { show(i); start(); });
  });
  scope.addEventListener('mouseenter', stop);
  scope.addEventListener('mouseleave', start);
  start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-tp"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root = document.currentScript ? document.currentScript.closest('.shopify-section') : null;
  const scope = root || document;
  const form = scope.querySelector('#tp-cart-form');
  if (!form) return;

  scope.querySelectorAll('.tp-qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const line = btn.dataset.line;
      const input = scope.querySelector('.tp-qty-input[data-line="' + line + '"]');
      if (!input) return;
      let val = parseInt(input.value, 10) || 0;
      val = btn.dataset.action === 'increase' ? val + 1 : Math.max(0, val - 1);
      input.value = val;
      form.submit();
    });
  });

  scope.querySelectorAll('.tp-qty-input').forEach(input => {
    input.addEventListener('change', () => {
      let val = parseInt(input.value, 10);
      if (isNaN(val) || val < 0) val = 0;
      input.value = val;
      form.submit();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-tp"] && !Shopify.designMode) return;
  try {
    
(function(){
  const filterToggles = document.querySelectorAll('[data-tp-filter-toggle]');
  const sidebar = document.querySelector('[data-tp-sidebar]');
  const backdrop = document.querySelector('[data-tp-backdrop]');
  const closeBtn = document.querySelector('[data-tp-filter-close]');
  const DRAWER_KEY = 'tp-filter-drawer-open';

  function openDrawer() {
    if (!sidebar) return;
    sidebar.classList.add('tp-open');
    if (backdrop) backdrop.classList.add('tp-open');
    document.body.classList.add('tp-drawer-open');
    filterToggles.forEach(t => t.setAttribute('aria-expanded', 'true'));
  }
  function closeDrawer() {
    if (!sidebar) return;
    sidebar.classList.remove('tp-open');
    if (backdrop) backdrop.classList.remove('tp-open');
    document.body.classList.remove('tp-drawer-open');
    filterToggles.forEach(t => t.setAttribute('aria-expanded', 'false'));
    try { sessionStorage.removeItem(DRAWER_KEY); } catch(e) {}
  }
  filterToggles.forEach(t => t.addEventListener('click', openDrawer));
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  // Auto-submit on filter change (works on desktop AND mobile)
  const filterForm = document.getElementById('tp-filter-form');
  if (filterForm) {
    filterForm.addEventListener('change', (e) => {
      if (!e.target.matches('[data-tp-filter-input]')) return;
      // On mobile only: remember to re-open drawer after page reload
      if (window.innerWidth < 1024) {
        try { sessionStorage.setItem(DRAWER_KEY, '1'); } catch(err) {}
      }
      filterForm.submit();
    });
  }
  // On page load: if we just submitted from drawer, re-open it
  try {
    if (sessionStorage.getItem(DRAWER_KEY) === '1' && window.innerWidth < 1024) {
      openDrawer();
    }
  } catch(e) {}

  const i18nScript = document.querySelector('script[id^="tp-collection-i18n-"]');
  const i18n = i18nScript ? JSON.parse(i18nScript.textContent) : { in_stock: 'In stock', out_of_stock: 'Out of stock', add_to_cart: 'Add to cart', unavailable: 'Unavailable' };

  function initCards(scope) {
    scope.querySelectorAll('.tp-product-card[data-product-id]').forEach(card => {
      if (card.dataset.tpInit === '1') return;
      card.dataset.tpInit = '1';

      const dataScript = card.querySelector('.tp-card-variants-data');
      if (!dataScript) return;
      let variants;
      try { variants = JSON.parse(dataScript.textContent); } catch(e) { return; }
      if (!variants || !variants.length) return;

      const pills = card.querySelectorAll('.tp-card-variant-pill');
      const priceDisplay = card.querySelector('[data-price-display]');
      const variantInput = card.querySelector('[data-variant-input]');
      const addBtn = card.querySelector('[data-add-btn]');
      const addText = card.querySelector('[data-add-text]');
      const stockEl = card.querySelector('[data-stock-display]');
      const imgEl = card.querySelector('.tp-card-image img');
      const defaultImg = imgEl ? imgEl.src : null;

      function formatPrice(cents){
        return '€' + (cents / 100).toFixed(2).replace('.', ',');
      }

      function getSelectedOpts() {
        const groups = {};
        pills.forEach(p => {
          if (p.classList.contains('active')) {
            groups[p.dataset.optionIndex] = p.dataset.optionValue;
          }
        });
        const opts = [];
        for (let i = 0; i < 3; i++) {
          if (groups[i] !== undefined) {
            opts.push(groups[i]);
          } else {
            opts.push(variants[0]['option' + (i + 1)]);
          }
        }
        return opts;
      }

      function findVariant(opts) {
        return variants.find(v =>
          (v.option1 === opts[0] || (v.option1 == null && opts[0] == null)) &&
          (v.option2 === opts[1] || (v.option2 == null && opts[1] == null)) &&
          (v.option3 === opts[2] || (v.option3 == null && opts[2] == null))
        );
      }

      function updateCard() {
        const opts = getSelectedOpts();
        const variant = findVariant(opts);
        if (!variant) return;

        if (priceDisplay) priceDisplay.textContent = formatPrice(variant.price);
        if (variantInput) variantInput.value = variant.id;
        if (imgEl) {
          imgEl.src = variant.image || defaultImg;
        }
        if (addBtn) {
          addBtn.disabled = !variant.available;
          if (addText) addText.textContent = variant.available ? i18n.add_to_cart : i18n.unavailable;
        }
        if (stockEl) {
          stockEl.classList.toggle('in-stock', variant.available);
          stockEl.classList.toggle('out-of-stock', !variant.available);
          const stockText = stockEl.querySelector('[data-stock-text]');
          if (stockText) stockText.textContent = variant.available ? i18n.in_stock : i18n.out_of_stock;
        }
      }

      pills.forEach(pill => {
        pill.addEventListener('click', (e) => {
          e.preventDefault();
          const idx = pill.dataset.optionIndex;
          card.querySelectorAll('.tp-card-variant-pill[data-option-index="' + idx + '"]').forEach(p => p.classList.remove('active'));
          pill.classList.add('active');
          updateCard();
        });
      });
    });
  }

  initCards(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-header-tp"] && !Shopify.designMode) return;
  try {
    
(function () {
  const header = document.querySelector('.tph');
  if (!header) return;
  const threshold = 80;
  let ticking = false;
  function update() {
    if (window.scrollY > threshold) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });
  update();

  // Mobile drawer
  const drawer = document.querySelector('[data-tp-drawer]');
  const backdrop = document.querySelector('[data-tp-drawer-backdrop]');
  const openBtns = document.querySelectorAll('[data-tp-drawer-open]');
  const closeBtns = document.querySelectorAll('[data-tp-drawer-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  openBtns.forEach(b => b.addEventListener('click', openDrawer));
  closeBtns.forEach(b => b.addEventListener('click', closeDrawer));
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  // Drawer "Show all products" toggle
  const catsToggle = document.querySelector('[data-tp-cats-toggle]');
  if (catsToggle) {
    const totalCount = catsToggle.getAttribute('data-tp-cats-total');
    catsToggle.addEventListener('click', () => {
      const expanded = catsToggle.getAttribute('aria-expanded') === 'true';
      const extras = document.querySelectorAll('[data-tp-cats-extra]');
      const txt = catsToggle.querySelector('[data-tp-cats-toggle-text]');
      extras.forEach(el => el.classList.toggle('is-shown', !expanded));
      catsToggle.setAttribute('aria-expanded', String(!expanded));
      if (txt) txt.textContent = expanded ? ('Show all (' + totalCount + ')') : 'Show less';
    });
  }

  // Desktop nav: hover-with-delay (300ms open, 150ms close) for All products + nav items
  const catsDetails = document.querySelector('.tph-cats');
  const navItems = document.querySelectorAll('.tph-nav-item');
  const isHoverDevice = window.matchMedia('(hover: hover) and (min-width: 1101px)').matches;
  const HOVER_OPEN_DELAY = 150;
  const HOVER_CLOSE_DELAY = 120;

  function closeAllNavDropdowns() {
    navItems.forEach(other => other.classList.remove('is-open'));
    if (catsDetails && catsDetails.hasAttribute('open')) catsDetails.removeAttribute('open');
  }

  if (isHoverDevice) {
    // All products mega-menu — hover with delay
    if (catsDetails) {
      let openTimer, closeTimer;
      catsDetails.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        openTimer = setTimeout(() => {
          navItems.forEach(other => other.classList.remove('is-open'));
          catsDetails.setAttribute('open', '');
        }, HOVER_OPEN_DELAY);
      });
      catsDetails.addEventListener('mouseleave', () => {
        clearTimeout(openTimer);
        closeTimer = setTimeout(() => catsDetails.removeAttribute('open'), HOVER_CLOSE_DELAY);
      });
    }

    // Nav items with dropdowns — hover with delay
    navItems.forEach(item => {
      if (!item.querySelector('.tph-nav-dropdown')) return;
      let openTimer, closeTimer;
      item.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        openTimer = setTimeout(() => {
          closeAllNavDropdowns();
          item.classList.add('is-open');
        }, HOVER_OPEN_DELAY);
      });
      item.addEventListener('mouseleave', () => {
        clearTimeout(openTimer);
        closeTimer = setTimeout(() => item.classList.remove('is-open'), HOVER_CLOSE_DELAY);
      });
    });
  }

  // Click-to-open dropdowns on nav-items with children (works on touch + as fallback)
  navItems.forEach(item => {
    const link = item.querySelector('.tph-nav-link.has-arrow');
    if (!link) return;
    link.addEventListener('click', (e) => {
      if (!item.classList.contains('is-open')) {
        e.preventDefault();
        closeAllNavDropdowns();
        item.classList.add('is-open');
      }
    });
  });
  // Close opened items on outside click
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.tph-nav-item') && !e.target.closest('.tph-cats')) {
      navItems.forEach(item => item.classList.remove('is-open'));
    }
  });

  // Brand logo preview on hover
  document.querySelectorAll('.tph-nav-dropdown').forEach(dd => {
    const preview = dd.querySelector('[data-tp-brand-preview]');
    if (!preview) return;
    const defaultContent = preview.innerHTML;
    dd.querySelectorAll('[data-tp-brand-hover]').forEach(link => {
      link.addEventListener('mouseenter', () => {
        const logo = link.dataset.logo;
        const name = link.dataset.name || '';
        if (logo) preview.innerHTML = `<img src="${logo}" alt="${name}" loading="lazy">`;
      });
    });
    dd.addEventListener('mouseleave', () => {
      preview.innerHTML = defaultContent;
    });
  });


  // USP ticker cycle (mobile only — desktop shows them inline via flex)
  const uspContainer = document.querySelector('[data-tp-usp-cycle]');
  if (uspContainer) {
    const usps = uspContainer.querySelectorAll('.tph-usp');
    if (usps.length > 1) {
      let idx = 0;
      usps[0].classList.add('is-active');
      setInterval(() => {
        usps[idx].classList.remove('is-active');
        idx = (idx + 1) % usps.length;
        usps[idx].classList.add('is-active');
      }, 4000);
    } else if (usps.length === 1) {
      usps[0].classList.add('is-active');
    }
  }

  // Predictive search dropdown
  function initSearchSuggest() {
    const form = document.querySelector('[data-tp-search]');
    if (!form) return;
    const input = form.querySelector('[data-tp-search-input]');
    const panel = form.querySelector('[data-tp-search-suggest]');
    const list = form.querySelector('[data-tp-search-list]');
    const allLink = form.querySelector('[data-tp-search-all]');
    if (!input || !panel || !list) return;

    let debounceId = null;
    let currentReq = null;
    let lastQ = '';

    function formatMoney(cents) {
      const num = (cents / 100);
      return '€' + num.toFixed(2).replace('.', ',');
    }
    function hidePanel() { panel.setAttribute('hidden', ''); }
    function showPanel() { panel.removeAttribute('hidden'); }

    function render(products, q) {
      list.innerHTML = '';
      if (!products || !products.length) {
        list.innerHTML = '<div class="tph-search-suggest-empty">No results for "' + q.replace(/</g, '&lt;') + '"</div>';
      } else {
        products.slice(0, 6).forEach(p => {
          const a = document.createElement('a');
          a.className = 'tph-search-suggest-item';
          a.href = p.url;
          const imgSrc = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          const imgAlt = (p.featured_image && p.featured_image.alt) || p.title || '';
          a.innerHTML = '<div class="tph-search-suggest-img">' +
            (imgSrc ? '<img src="' + imgSrc + '" alt="' + imgAlt.replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
            '</div>' +
            '<div class="tph-search-suggest-info">' +
              '<span class="tph-search-suggest-title">' + (p.title || '').replace(/</g, '&lt;') + '</span>' +
              (typeof p.price === 'number' ? '<span class="tph-search-suggest-price">' + formatMoney(p.price) + '</span>' : '') +
            '</div>';
          list.appendChild(a);
        });
      }
      if (allLink) allLink.setAttribute('href', '/search?q=' + encodeURIComponent(q));
      showPanel();
    }

    function fetchSuggest(q) {
      if (currentReq) currentReq.abort();
      const ctrl = new AbortController();
      currentReq = ctrl;
      const url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,vendor,product_type,variants.title,variants.sku,variants.barcode,tag';
      fetch(url, { signal: ctrl.signal })
        .then(r => r.json())
        .then(data => {
          const products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          render(products, q);
        })
        .catch(err => { if (err.name !== 'AbortError') hidePanel(); });
    }

    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(debounceId);
      if (q.length < 2) { hidePanel(); lastQ = ''; return; }
      if (q === lastQ) return;
      lastQ = q;
      debounceId = setTimeout(() => fetchSuggest(q), 180);
    });
    input.addEventListener('focus', () => { if (input.value.trim().length >= 2 && list.children.length) showPanel(); });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) hidePanel(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') hidePanel(); });
  }
  initSearchSuggest();

  function appendQueryToLangLinks() {
    var search = location.search;
    if (!search) return;
    document.querySelectorAll('[data-tph-lang-list] a').forEach(function(a) {
      if (a.hostname === location.hostname && a.href.indexOf('?') === -1) {
        a.href = a.href + search;
      }
    });
  }
  appendQueryToLangLinks();

  function initLangDropdown() {
    document.querySelectorAll('[data-tph-lang]').forEach(function(el) {
      var btn = el.querySelector('[data-tph-lang-toggle]');
      var list = el.querySelector('[data-tph-lang-list]');
      if (!btn || !list) return;
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var open = list.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', function(e) {
        if (!el.contains(e.target)) {
          list.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          list.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }
  initLangDropdown();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-tp"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root = document.currentScript ? document.currentScript.closest('.shopify-section') : null;
  const scope = root || document;
  const dataScript = scope.querySelector('script[id^="tp-product-data-"]');
  if (!dataScript) return;
  const productData = JSON.parse(dataScript.textContent);
  const i18nScript = scope.querySelector('script[id^="tp-product-i18n-"]');
  const i18n = i18nScript ? JSON.parse(i18nScript.textContent) : { in_stock: 'In stock', out_of_stock: 'Out of stock', add_to_cart: 'Add to Cart', unavailable: 'Unavailable' };

  const qtyInput = scope.querySelector('#tp-qty-input');
  const unitEl = scope.querySelector('#tp-unit-price');
  const variantIdInput = scope.querySelector('#tp-variant-id');
  const skuEl = scope.querySelector('#tp-sku-display');
  const stockEl = scope.querySelector('#tp-stock-display');
  const cartBtn = scope.querySelector('.tp-pdp-cart-submit');
  const mainImg = scope.querySelector('#tp-main-img');
  const defaultImg = mainImg ? mainImg.src : null;

  function formatPrice(cents){
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function getSelectedOptions(){
    return productData.options.map((optName, idx) => {
      const activeBtn = scope.querySelector('.tp-pdp-option-btn[data-option-index="' + idx + '"].active');
      if (activeBtn) return activeBtn.dataset.optionValue;
      return productData.variants[0]['option' + (idx + 1)];
    });
  }

  function findVariant(selectedOpts){
    return productData.variants.find(v =>
      selectedOpts.every((opt, idx) => v['option' + (idx + 1)] === opt)
    );
  }

  function updateVariant(){
    const selected = getSelectedOptions();
    const variant = findVariant(selected);
    if (!variant) return;

    if (variantIdInput) variantIdInput.value = variant.id;
    if (mainImg) {
      mainImg.src = variant.image || defaultImg;
    }
    if (unitEl) {
      unitEl.dataset.price = variant.price;
      const priceItem = unitEl.querySelector('.price-item--sale, .price-item--regular, .price-item--last, .price-item');
      if (priceItem) priceItem.textContent = formatPrice(variant.price);
    }
    if (skuEl && variant.sku) skuEl.textContent = variant.sku;
    scope.querySelectorAll('.tp-js-sku').forEach(el => { if (variant.sku) el.textContent = variant.sku; });
    scope.querySelectorAll('.tp-js-mpn').forEach(el => {
      el.textContent = variant.mpn || '';
    });
    scope.querySelectorAll('.tp-js-mpn-wrap').forEach(el => {
      el.style.display = variant.mpn ? '' : 'none';
    });
    scope.querySelectorAll('.tp-js-ean').forEach(el => {
      el.textContent = variant.ean || '';
    });
    scope.querySelectorAll('.tp-js-ean-wrap').forEach(el => {
      el.style.display = variant.ean ? '' : 'none';
    });
    scope.querySelectorAll('.tp-js-warranty').forEach(el => {
      const fallbackWarranty = el.dataset.warrantyBase || '';
      el.textContent = variant.warranty || fallbackWarranty;
    });
    scope.querySelectorAll('.tp-js-jacket-color').forEach(el => {
      const fallbackColor = el.dataset.jacketColorBase || '';
      el.textContent = variant.jacket_color || fallbackColor;
    });
    scope.querySelectorAll('.tp-js-variant-suffix').forEach(el => {
      const fallbackSuffix = el.dataset.variantSuffixBase || '';
      const newSuffix = (variant.suffix !== undefined && variant.suffix !== null) ? variant.suffix : fallbackSuffix;
      el.textContent = newSuffix;
      el.style.display = newSuffix === '' ? 'none' : '';
    });
    if (stockEl) {
      stockEl.classList.toggle('in-stock', variant.available);
      stockEl.classList.toggle('out-of-stock', !variant.available);
      stockEl.innerHTML = variant.available
        ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg> ' + i18n.in_stock
        : i18n.out_of_stock;
    }
    if (cartBtn) {
      cartBtn.disabled = !variant.available;
      const span = cartBtn.querySelector('span');
      if (span) span.textContent = variant.available ? i18n.add_to_cart : i18n.unavailable;
    }
    if (window.history && window.history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  const optionBtns = scope.querySelectorAll('.tp-pdp-option-btn');
  optionBtns.forEach(btn => btn.addEventListener('click', () => {
    const idx = btn.dataset.optionIndex;
    scope.querySelectorAll('.tp-pdp-option-btn[data-option-index="' + idx + '"]').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    updateVariant();
  }));

  const qtyMinus = scope.querySelector('#tp-qty-minus');
  const qtyPlus = scope.querySelector('#tp-qty-plus');
  if (qtyMinus) qtyMinus.addEventListener('click', () => { qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1); });
  if (qtyPlus) qtyPlus.addEventListener('click', () => { qtyInput.value = parseInt(qtyInput.value, 10) + 1; });

  // Request a quote: add current variant to cart, then redirect to quote app
  const quoteBtn = scope.querySelector('#tp-quote-btn');
  if (quoteBtn) {
    quoteBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      const quoteUrl = quoteBtn.dataset.quoteUrl || '/cart';
      const variantId = variantIdInput ? variantIdInput.value : null;
      const quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      quoteBtn.style.pointerEvents = 'none';
      quoteBtn.style.opacity = '0.7';
      try {
        if (variantId) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: quantity })
          });
        }
      } catch (err) {
        console.warn('Quote: cart add failed, redirecting anyway', err);
      }
      window.location.href = quoteUrl;
    });
  }

  const thumbs = scope.querySelectorAll('.tp-pdp-thumbnail');
  thumbs.forEach(t => t.addEventListener('click', () => {
    thumbs.forEach(x => x.classList.remove('active'));
    t.classList.add('active');
    if (mainImg && t.dataset.img) mainImg.src = t.dataset.img;
  }));

  const tabBtns = scope.querySelectorAll('.tp-pdp-tab-btn');
  let clickLock = false;
  let clickLockTimer = null;
  tabBtns.forEach(btn => btn.addEventListener('click', (e) => {
    if (!btn.dataset.anchor) return;
    e.preventDefault();
    const target = scope.querySelector('#' + btn.dataset.anchor);
    if (!target) return;
    // Lock scroll-spy during smooth scroll so observer can't override the clicked tab
    clickLock = true;
    if (clickLockTimer) clearTimeout(clickLockTimer);
    clickLockTimer = setTimeout(() => { clickLock = false; }, 1000);
    tabBtns.forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));
  // Scroll-spy: highlight tab matching the section currently in view
  const sectionIds = ['tp-section-specs', 'tp-section-certs', 'tp-section-docs', 'tp-section-reviews'];
  const sections = sectionIds.map(id => scope.querySelector('#' + id)).filter(Boolean);
  if ('IntersectionObserver' in window && sections.length) {
    const spy = new IntersectionObserver((entries) => {
      if (clickLock) return;
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const id = entry.target.id;
          tabBtns.forEach(b => {
            b.classList.toggle('active', b.dataset.anchor === id);
          });
        }
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    sections.forEach(s => spy.observe(s));
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
(function(){
  const filterToggles = document.querySelectorAll('[data-tp-filter-toggle]');
  const sidebar = document.querySelector('[data-tp-sidebar]');
  const backdrop = document.querySelector('[data-tp-backdrop]');
  const closeBtn = document.querySelector('[data-tp-filter-close]');
  const DRAWER_KEY = 'tp-search-drawer-open';

  function openDrawer() {
    if (!sidebar) return;
    sidebar.classList.add('tp-open');
    if (backdrop) backdrop.classList.add('tp-open');
    document.body.classList.add('tp-drawer-open');
    filterToggles.forEach(t => t.setAttribute('aria-expanded', 'true'));
  }
  function closeDrawer() {
    if (!sidebar) return;
    sidebar.classList.remove('tp-open');
    if (backdrop) backdrop.classList.remove('tp-open');
    document.body.classList.remove('tp-drawer-open');
    filterToggles.forEach(t => t.setAttribute('aria-expanded', 'false'));
    try { sessionStorage.removeItem(DRAWER_KEY); } catch(e) {}
  }
  filterToggles.forEach(t => t.addEventListener('click', openDrawer));
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  const filterForm = document.getElementById('tp-filter-form');
  if (filterForm) {
    filterForm.addEventListener('change', (e) => {
      if (!e.target.matches('[data-tp-filter-input]')) return;
      if (window.innerWidth < 1024) {
        try { sessionStorage.setItem(DRAWER_KEY, '1'); } catch(err) {}
      }
      filterForm.submit();
    });
  }
  try {
    if (sessionStorage.getItem(DRAWER_KEY) === '1' && window.innerWidth < 1024) {
      openDrawer();
    }
  } catch(e) {}
})();

  } catch(e) { console.error(e); }
})();
})();
